import Button from 'components/form/Button';
import { InputWithoutControl } from 'components/form/Input';
import React from 'react';

const Contact = () => {
  document.title = 'Contact Us';

  return (
    <section className="mb-10">
      <div className="relative text-white">
        <img
          src="/assets/images/contact.jpg"
          alt="about"
          className="w-full object-cover brightness-75 lg:h-[580px]"
        />
        <div className="container absolute top-5 mx-auto h-[200px] px-5 md:h-[300px] lg:top-28 lg:left-9">
          <div className="mt-10 py-5">
            <div className="my-auto">
              <h3 className="text-[40px]">CONTACT US</h3>
              <p className="my-3 text-2xl">Hi, we're here to help.</p>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="mx-auto w-full py-20 md:w-1/2">
        <div className="flex justify-center gap-x-3">
          <div className="basis-[70%]">
            <InputWithoutControl
              containerClass="bg-white"
              placeholder="Enter email"
            />
          </div>
          <Button className="rounded-md bg-blue-500 py-2 px-3 text-white">
            submit
          </Button>
        </div>
        <br />
        <div className="my-4 flex flex-col justify-between gap-8 lg:flex-row">
          <div className="mx-auto flex flex-col gap-y-3">
            <span className="mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                />
              </svg>
            </span>
            <a href="mailto:info@blockchaincapital.com">
              info@blockchaincapital.com
            </a>
          </div>
          <div className="mx-auto flex flex-col gap-y-3">
            <span className="mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                />
              </svg>
            </span>
            <p>+1 (281) 310-0243</p>
          </div>
          <div className="mx-auto flex flex-col gap-y-3">
            <span className="mx-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-6 w-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                />
              </svg>
            </span>
            <p>56 NE 186th Ter Miami, Florida (FL), 33179</p>
          </div>
        </div>
      </div>
      <hr />
    </section>
  );
};

export default Contact;
